import { useMemo, useState } from "react";
import { get } from "lodash";
import { generateUUID } from "utills/helpers";
import { InValidTableType } from "routes/group/pages/edit";
import Button from "components/button";
import { Modal } from "components/modal";
import Pagination from "components/pagination";

interface PagingType {
  total_item: number;
  total_page: number;
  current_page: number;
}

interface PropType {
  open: boolean;
  data: InValidTableType[];
  handleClose: () => void;
}

const InValidImportAttendantModal = (props: PropType) => {
  const { open, data, handleClose } = props;

  const PAGE_SIZE = 5;
  const [page, setPage] = useState<number>(1);

  // Paginated data
  const PAGINATED_DATA = useMemo(() => {
    if (!data) return [];

    const start = (page - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE;

    return data.slice(start, end);
  }, [data, page]);

  // Paging info
  const invalidPaging: PagingType = useMemo(() => {
    return {
      total_item: data?.length || 0,
      total_page: Math.ceil((data?.length || 0) / PAGE_SIZE),
      current_page: page,
    };
  }, [data, page]);

  const handlePageChange = (value: number) => {
    setPage(value);
  };

  const handleCloseModal = () => {
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      title="Invalid Import Attendants Data"
      closeOnClickBackdrop={false}
    >
      <div className="p-6 flex flex-col gap-8">
        <div className="max-w-full md:max-w-[80vw] flex flex-col gap-5">
          <div className="w-full overflow-y-auto">
            <table className="mb-6 w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
              <thead>
                <tr>
                  <th className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">Row</th>
                  <th className="th">Field</th>
                  <th className="th">Value</th>
                  <th className="th">Message</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200 bg-white">
                {PAGINATED_DATA.map((item) => (
                  <tr key={generateUUID()}>
                    <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                      {item.row}
                    </td>

                    <td className="td font-medium text-gray-700">{item.key}</td>

                    <td className="td font-medium text-gray-700">
                      {item.value}
                    </td>

                    <td className="td whitespace-pre-wrap max-w-[320px]">
                      {item.message}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={get(invalidPaging, "current_page", 1)}
            totalPage={get(invalidPaging, "total_page", 0)}
            total={{
              totalItems: get(PAGINATED_DATA, "length", 0),
              total: get(invalidPaging, "total_item", 0),
            }}
            onChange={handlePageChange}
          />
        </div>

        <div className="flex items-center justify-end gap-x-3">
          <Button
            className="w-20 bg-white text-brand-500 border border-solid border-brand-500 hover:bg-gray-50 active:bg-gray-100"
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InValidImportAttendantModal;
